import { CustomTable } from "@/components/Tables/CustomTable"
import { columns } from "./Columns"
import { useCustomQuery } from "@/hooks/useCustomQuery"
import AddIcon from "@mui/icons-material/Add"
import AddCurrencyNoteModal from "./Model"
import { CrudProvider, useCrudContext } from "@/context/crudContext"
import { DetailTable } from "@/components/Tables/DetailTable"
import { apiFetch } from "@/hooks/apiFetch"
import { useEffect, useState } from "react"
import { Button } from "@mui/material"
import ClearIcon from "@mui/icons-material/Clear"
import IconButton from "@mui/material/IconButton"
import { toast } from "sonner"

export default function CurrencyNoteList() {
  const breadcrumbs = [
    { label: "Dashboard", url: "/" },
    { label: "Attribute Type" },
  ]
  return (
    <>
      {/* Breadcrumb */}
      <div className="breadcrumb-card">
        <h5>Currency Notes</h5>
      </div>

      <CrudProvider>
        <DenominationList />
      </CrudProvider>
    </>
  )
}

function DenominationList() {
  const [currencies, setCurrencies] = useState([]);
  const [openAddDialog, setOpenAddDialog] = useState(false)

  const transferData = (arr) => {
    return arr.map((item) => ({key: 'note', value: item}))
  }

  useEffect(() => {
    apiFetch('cash/currencies-notes')
      .then((res) => {
        console.log('curr', res.denominations)
        const arrayOfNotes = transferData(res.denominations.npr)
        setCurrencies(arrayOfNotes)
    })
  }, []);

  const addCurrency = async (newCurrency) => {
  try {
    // 1. Normalize input
    const value = Number(newCurrency)

    if (Number.isNaN(value) || value <= 0) {
      toast.error("Invalid currency value")
      return
    }

    // 2. Extract existing values
    const existingValues = currencies.map((c) => Number(c.value))

    // 3. Prevent duplicates
    if (existingValues.includes(value)) {
      toast.error("Currency already exists")
      return
    }

    // 4. Add + SORT ASCENDING
    const updatedValues = [...existingValues, value].sort((a, b) => a - b)

    // 5. Send to server (ARRAY, SORTED)
    await apiFetch("cash/currencies-note/update", {
      method: "POST",
      body: JSON.stringify({
        notes: updatedValues,
      }),
    })

    // 6. Update UI
    setCurrencies(transferData(updatedValues))
    setOpenAddDialog(false)

    toast.success('New note added')
  } catch (e) {
    toast.error(e?.message || "Something went wrong")
  }
  }
  
  const removeCurrency = async (valueToRemove) => {
  try {
    const updatedValues = currencies
      .map((c) => Number(c.value))
      .filter((v) => v !== valueToRemove)
      .sort((a, b) => a - b)

    await apiFetch("cash/currencies-note/update", {
      method: "POST",
      body: JSON.stringify({
        notes: updatedValues,
      }),
    })

    setCurrencies(transferData(updatedValues))
    toast.success('Note has been deleted')
  } catch (e) {
    toast.error(e?.message || "Failed to remove currency")
  }
}



  
  const col = [
    {
      header: "Amount",
         cell: ({ row }) => `Rs. ${row.original.value}`,
    },
    {
    header: "Action",
    size: 50,
    cell: ({ row }) => (
      <IconButton
        size="small"
        color="error"
        onClick={() => removeCurrency(Number(row.original.value))}
      >
         <i
                                  className="material-symbols-outlined"
                                  style={{
                                    fontSize: "16px",
                                  }}
                                >
                                  delete
                                </i>
      </IconButton>
    ),
  },
  ]

  return (
    <>
        <Button
        onClick={() => setOpenAddDialog(true)}
              variant="outlined"
              sx={{
                textTransform: "capitalize",
                borderRadius: "7px",
                fontWeight: "500",
                fontSize: "13px",
                padding: "6px 13px",
              }}
              color="primary"
            >
              <AddIcon sx={{ position: "relative", top: "-1px" }} />
              Add currency
            </Button>
        <DetailTable
          label="Denominations"
          columns={col}
          data={currencies}
          isLoading={false}
        />


      <AddCurrencyNoteModal open={openAddDialog} onClose={() => setOpenAddDialog(false)} onSubmit={(num) => addCurrency(Number(num))}/> 
    </>
  )
}
